import { useSyncExternalStore } from 'react';

export const SECURITY_MODE_STORAGE_KEY = 'security.mode';
export const SECURITY_MODE_QUERY_PARAM = 'security';
const CHANGE_EVENT = 'security-mode-changed';

export const readSecurityModeStored = (): '0' | '1' | null => {
  try {
    const v = localStorage.getItem(SECURITY_MODE_STORAGE_KEY);
    if (v === '0' || v === '1') return v;
    return null;
  } catch {
    return null;
  }
};

export const writeSecurityModeStored = (v: boolean) => {
  try {
    localStorage.setItem(SECURITY_MODE_STORAGE_KEY, v ? '1' : '0');
  } catch {
    // ignore
  }
  // localStorage writes don't fire 'storage' in the same tab — broadcast manually.
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
};

export const subscribeSecurityModeStored = (cb: () => void): (() => void) => {
  const onStorage = (e: StorageEvent) => {
    if (e.key === SECURITY_MODE_STORAGE_KEY) cb();
  };
  window.addEventListener('storage', onStorage);
  window.addEventListener(CHANGE_EVENT, cb);
  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(CHANGE_EVENT, cb);
  };
};

/** Lightweight hook usable anywhere (e.g. the menu) without the SecurityModeProvider. */
export const useSecurityModeStored = (): boolean =>
  useSyncExternalStore(
    subscribeSecurityModeStored,
    () => readSecurityModeStored() === '1',
    () => false,
  );